export { default } from "./MailingListDetails";



// WEBPACK FOOTER //
// ./src/components/MailingListDetails/index.ts